import React from "react";
import { Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import moment from "moment";

import transactions from "@/api/transactions";
import reports from "@/api/reports";

import TransactionsTable from "../Components/TransactionsTable";
import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import { APP_CONST } from "@/store/dataStore";

const loadTransactions = transactions.searchAdapter({
  direction: "INCOMING",
  directionSubject: "incoming",
  fromDate: moment()
    .subtract(APP_CONST.REPORT_BACK_DAYS(), "days")
    .format("YYYY-MM-DDT00:00:00+07:00"),
  toDate: moment().format("YYYY-MM-DDT00:00:00+07:00"),
});

var table = React.createRef();
const reloadTable = filter => {
  setImmediate(() => {
    table.loadAndStoreData();
  });
};

const IncomingTransaction = () => (
  <div className="animated fadeIn">
    <Row>
      <Col>
        <Card>
          <CardHeader>Incoming Transactions</CardHeader>
          <CardBody>
            <TableContainerWithLocation
              autoLoad={true}
              loadData={loadTransactions}
              onSearchQueryChanged={reloadTable}
              requestReport={reports.requestIncomingTransactions}
              isTransaction={true}
              reportWithoutDateRange={false}
              reportWithInitialDates={{
                dateFrom: moment().subtract(
                  APP_CONST.REPORT_BACK_DAYS(),
                  "days",
                ),
                dateTo: moment(),
              }}
              wrappedComponentRef={innerComponent => {
                // Forwarding ref to TableContainerWithLocation through 'withRouter' HOC
                // This is the only way to forward ref with React Router 4
                if (innerComponent) {
                  table = innerComponent;
                }
              }}>
              <TransactionsTable
                type="incoming"
                businessStatusFilter
                statusFilter
                onNavigate={reloadTable}
              />
            </TableContainerWithLocation>
          </CardBody>
        </Card>
      </Col>
    </Row>
  </div>
);

export default IncomingTransaction;
